import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Divider } from '@mui/material';

import MassActionCriteriaField from './MassActionCriteriaField';

const isRemovable = (criteria, criterias) => {
  const removable =
    !!criteria.model.parentDescriptor ||
    !criteria.model.mandatory ||
    Object.keys(criterias[criteria.model.key].criteriaValues).length > 1;

  return removable;
};

const SelectedCriteriaList = ({
  criterias,
  groupName,
  selectionValidity,
  isWritable,
  onCriteriaValueChange,
  onRemoveCriteria,
  onOperatorValueChange,
}) => (
  <>
    {Object.values(criterias).map(criteria => (
      <Fragment key={criteria.model.key}>
        {Object.entries(criteria.criteriaValues).map(([uniqueId, criteriaValue]) => (
          <MassActionCriteriaField
            key={uniqueId}
            isWritable={isWritable}
            uniqueId={uniqueId}
            groupName={groupName}
            model={criteria.model}
            value={criteriaValue}
            removable={isWritable && isRemovable(criteria, criterias)}
            validity={selectionValidity.validities[uniqueId] || { isValid: true, messages: [] }}
            groupDisplayNames={criteria.groupDisplayNames}
            onCriteriaValueChange={onCriteriaValueChange}
            removeCriteria={onRemoveCriteria}
            onOperatorValueChange={onOperatorValueChange}
          />
        ))}
        <Divider style={{ margin: '8px 28px 0 28px' }} />
      </Fragment>
    ))}
  </>
);

SelectedCriteriaList.propTypes = {
  criterias: PropTypes.object.isRequired,
  groupName: PropTypes.string.isRequired,
  selectionValidity: PropTypes.object.isRequired,
  isWritable: PropTypes.bool.isRequired,
  onRemoveCriteria: PropTypes.func.isRequired,
  onCriteriaValueChange: PropTypes.func.isRequired,
};

export default SelectedCriteriaList;
